const validatePassword = (password) => {
  const hasUpperCase = /[A-Z]/.test(password);
  const hasNumber = /\d/.test(password);
  const hasMinLength = password.length >= 8;
  const hasSymbol = /[!@#$%^&*(),.?":{}|<>+]/.test(password);

  return hasUpperCase && hasNumber && hasMinLength && hasSymbol;
};

export default validatePassword;
